import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  GET_USERS: createSagaAction('GET_USERS'),
  GET_ALL_USERS: createSagaAction('GET_ALL_USERS'),
  GET_USER_ROLES: createSagaAction('GET_USER_ROLES'),
  USER_UPDATE: createSagaAction('USER_UPDATE'),
  USER_DELETE: createSagaAction('USER_DELETE'),
  USER_CREATE: createSagaAction('USER_CREATE'),
  SET_INITIAL_PASSWORD: createSagaAction('SET_INITIAL_PASSWORD')
}

// Action Creators
export const actions = {
  getUsers: () => ({
    type: constants.GET_USERS.ACTION
  }),
  getAllUsers: () => ({
    type: constants.GET_ALL_USERS.ACTION
  }),
  getUserRoles: () => ({
    type: constants.GET_USER_ROLES.ACTION
  }),
  setInitialPassword: ({ username, password }) => ({
    type: constants.SET_INITIAL_PASSWORD.ACTION,
    username,
    password
  }),
  userUpdate: (id, payload) => ({ type: constants.USER_UPDATE.ACTION, id, payload }),
  userDelete: (id, payload) => ({ type: constants.USER_DELETE.ACTION, id, payload }),
  userCreate: payload => ({ type: constants.USER_CREATE.ACTION, payload })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_USERS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_USERS.SUCCESS:
      return {
        ...state,
        users: action.payload
      }
    case constants.GET_ALL_USERS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_ALL_USERS.SUCCESS:
      return {
        ...state,
        users: action.payload
      }
    case constants.GET_USER_ROLES.SUCCESS:
      return {
        ...state,
        roles: action.roles
      }
    case constants.SET_INITIAL_PASSWORD.SUCCESS:
      return {
        ...state,
        passwordChange: action.payload
      }
    case constants.USER_UPDATE.SUCCESS:
      return state
    case constants.USER_DELETE.SUCCESS:
      return state

    case constants.USER_CREATE.ACTION:
      return { ...state, error: null, loading: true }
    case constants.USER_CREATE.SUCCESS:
      return {
        ...state,
        users: action.payload,
        loading: false
      }
    case constants.USER_CREATE.FAILED:
      return {
        ...state,
        message: action.message,
        loading: false
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/userActions.js